import { Cloudinary } from "@cloudinary/url-gen";

const cld = new Cloudinary({
  cloud: {
    cloudName: process.env.REACT_APP_CLOUD_NAME,
  },
  url: {
    secure: true,
  },
});

/**
 * Given a Cloudinary publicId (without extension) and its fileType (e.g. "webp", "jpg"),
 * returns the full HTTPS URL.
 *
 * @param {string} publicId  - e.g. "uploads/12345/2025/6/97898feb-bf83-484c-bb69-747bdba2adc1"
 * @param {string} fileType  - e.g. "webp", "jpg", "png"
 * @returns {string}         - e.g. "https://res.cloudinary.com/.../uploads/.../97898feb...adc1.webp"
 */
function makeFullUrl(publicId, fileType) {
  // If fileType is “webp”, chain .format("webp") so that the URL ends in “.webp”
  return cld
    .image(publicId)
    .format(fileType) // e.g. "webp", "jpg", etc.
    .toURL();
}

export default makeFullUrl;
